// extracted by mini-css-extract-plugin
export default {"footer":"A-z","footerContainer":"B-z"};